const PrivacyPolicy = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto text-gray-800">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
      <p className="mb-4">Last updated: April 10, 2025</p>

      <p className="mb-4">
        We value your privacy. This Privacy Policy describes how your personal
        information is collected, used, and shared when you visit our website,{" "}
        <strong>Plog Social</strong> (“we”, “our”, or “us”).
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        1. Information We Collect
      </h2>
      <ul className="list-disc list-inside mb-4">
        <li>
          <strong>Personal Information:</strong> Such as your name, email
          address, and other contact information when you fill out a form or
          create an account.
        </li>
        <li>
          <strong>Usage Data:</strong> This includes information about your
          device, browser, IP address, time zone, and how you interact with our
          site.
        </li>
        <li>
          <strong>Cookies and Tracking Technologies:</strong> We use cookies and
          similar technologies to analyze trends, administer the site, track
          users’ movements, and gather demographic information.
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        2. How We Use Your Information
      </h2>
      <ul className="list-disc list-inside mb-4">
        <li>Improve and personalize your experience on our website</li>
        <li>Respond to your questions or support requests</li>
        <li>Send periodic emails or updates (only if you opt in)</li>
        <li>
          Display relevant advertisements via Google AdSense and similar
          networks
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        3. Google AdSense and Cookies
      </h2>
      <p className="mb-4">
        Our website uses Google AdSense, a service for including advertisements.
        Google may use cookies to serve ads based on a user’s prior visits to
        our site or other websites.
      </p>
      <p className="mb-4">
        Google’s use of advertising cookies enables it and its partners to serve
        ads to users based on their visit to our site and/or other sites on the
        Internet.
      </p>
      <p className="mb-4">
        Users may opt out of personalized advertising by visiting{" "}
        <a
          href="https://www.google.com/settings/ads"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline"
        >
          Ads Settings
        </a>
        .
      </p>
      <p className="mb-4">
        You can also visit{" "}
        <a
          href="https://www.aboutads.info"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline"
        >
          www.aboutads.info
        </a>{" "}
        to opt out of a third-party vendor's use of cookies for personalized
        advertising.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        4. Third-Party Services
      </h2>
      <p className="mb-4">
        We may use third-party tools or services (such as analytics or ad
        networks) that collect, monitor, and analyze this type of information to
        improve our services and show relevant ads.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Data Sharing</h2>
      <p className="mb-4">
        We do not sell, trade, or rent users’ personal identification
        information to others. We may share generic aggregated demographic
        information not linked to any personal identification.
      </p>

      <p className="mt-8 text-sm text-gray-600">
        If you have any questions, feel free to contact us at{" "}
        <strong>QuintyneRealty@hotmail.com</strong>.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
